document.addEventListener('click', (event) => {
  const trigger = event.target.closest('.to-pdp-media-jump');
  if (!trigger) return;

  const mediaId = trigger.getAttribute('data-media-id');
  if (!mediaId) return;

  const productSection = trigger.closest('.shopify-section');
  const target = productSection?.querySelector(`[data-media-id="${mediaId}"]`)
    || document.querySelector(`[data-media-id="${mediaId}"]`);

  if (!target) return;

  event.preventDefault();

  const slide = target.closest('slideshow-slide') || target.closest('.product-media-container') || target;
  slide.scrollIntoView({
    behavior: 'smooth',
    block: 'nearest',
    inline: 'center',
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const productDetails = document.querySelector('.product-details');
  const productPrice = document.querySelector('product-price');
  const descriptionParagraph = document.querySelector('.product-details .text-block.rte p');

  function buildExcerpt(text) {
    const trimmed = (text || '').replace(/\s+/g, ' ').trim();
    if (!trimmed) return '';

    const firstSentence = trimmed.match(/.+?[.!?](\s|$)/)?.[0]?.trim() || trimmed;
    if (firstSentence.length <= 110) return firstSentence;

    const shortened = firstSentence.slice(0, 96);
    const lastSpace = shortened.lastIndexOf(' ');
    return `${shortened.slice(0, lastSpace > 55 ? lastSpace : shortened.length).trim()}...`;
  }

  function syncInlinePrice() {
    if (!productDetails || !productPrice) return;

    const saleNode = productPrice.querySelector('.price-item--sale');
    const regularNode = productPrice.querySelector('.compare-at-price');
    const titleNode = productDetails.querySelector('h1');
    if (!titleNode || !saleNode) return;

    let inlinePrice = productDetails.querySelector('.to-pdp-price-inline');
    if (!inlinePrice) {
      inlinePrice = document.createElement('div');
      inlinePrice.className = 'to-pdp-price-inline';
      titleNode.insertAdjacentElement('afterend', inlinePrice);
    }

    const saleText = saleNode.textContent?.trim() || '';
    const regularText = regularNode?.textContent?.trim() || '';
    inlinePrice.innerHTML = '';

    const sale = document.createElement('span');
    sale.className = 'to-pdp-price-inline__sale';
    sale.textContent = saleText;
    inlinePrice.appendChild(sale);

    if (regularText && regularText !== saleText) {
      const regular = document.createElement('span');
      regular.className = 'to-pdp-price-inline__compare';
      regular.textContent = regularText;
      inlinePrice.appendChild(regular);
    }
  }

  const titleTargets = [
    document.querySelector('.product-details h1'),
    document.querySelector('.sticky-add-to-cart__title'),
    document.querySelector('.to-pdp-breadcrumbs span:last-child'),
  ].filter(Boolean);

  for (const node of titleTargets) {
    const text = node.textContent?.trim();
    if (!text) continue;
    node.textContent = text.replace(/\s-\s[A-Z0-9]{4}$/i, '');
  }

  const textBlocks = Array.from(document.querySelectorAll('.product-details .text-block p'));
  for (const node of textBlocks) {
    const text = node.textContent?.trim();
    if (!text) continue;

    if (text.toUpperCase() === 'TRENDING') {
      node.classList.add('to-pdp-status-badge');
      continue;
    }

    if (descriptionParagraph === node) {
      node.textContent = buildExcerpt(text);
    }
  }

  syncInlinePrice();

  if (productPrice) {
    const observer = new MutationObserver(() => syncInlinePrice());
    observer.observe(productPrice, { childList: true, subtree: true, characterData: true });
  }
});
